import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

/**
 * Tooltip defaults for the dial-logs timeline components. A show delay keeps the
 * dense table from flashing a tooltip on every label the cursor passes over,
 * while hover-to-reveal still works. Provided at the component level so it only
 * affects tooltips inside these components, not the rest of the app.
 */
export const DIAL_LOGS_TOOLTIP_OPTIONS: MatTooltipDefaultOptions = {
    showDelay: 500,
    hideDelay: 0,
    touchendHideDelay: 1500,
};
